module.exports = __webpack_public_path__ + "img/00001.bb841a92.webp";